import styled from 'styled-components/macro'
import { TransparentButton } from '../Common/Buttons'
import { Link } from 'react-router-dom'

const AccessDenied = () => {
  return (
    <Container>
      <Message>You don't have permissions to access to this module.</Message>
      <TransparentButton>
        <Link to={`/`}>Go to login page</Link>
      </TransparentButton>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 20vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Message = styled.div`
  margin-bottom: 1rem;
  font-size: 1.5rem;
`

export default AccessDenied
